import { ReactElement } from 'react';
import { LazyLoadImage, LazyLoadImageProps } from 'react-lazy-load-image-component';
import './LazyImage.scss';

// The placeholder is static on purpose. It only stands in while the image is
// still off-screen, so nothing is loading yet, and a page of card rows mounts
// over a hundred of them: as MUI spinners they kept the main thread repainting
// every frame and made the rows on / scroll in jerks on phones.
const LazyImage = ({ className, ...restProps }: LazyLoadImageProps): ReactElement => (
  <LazyLoadImage
    {...restProps}
    placeholder={<span className='lazy-image__placeholder' />}
    className={`lazy-image ${className ?? ''}`}
  />
);

export default LazyImage;
